import React, { useState } from "react";
import { IonLabel, getPlatforms, isPlatform, IonInput, IonCheckbox } from "@ionic/react";
import "../../global.scss";
import {
	LOGIN_OR_SIGNUP,
	MOBILE_NUMBER,
	OTP_TEXT,
	CONTINUE,
	CONTINUE_USING_MOBILENUM,
	PLEASE_ENTER_VALID_MOBILE_NUMBER,
	T_AND_C_TEXT,
	TERMS_AND_CONDITIONS_CAP,
	IMPORTANT,
} from "../../constants";
import CustomTextField from "../CustomComponents/CustomTextField";
import { CustomButtonMobile, CutsomButtom } from "../CustomComponents/CustomButton";
import {
	signInWithPhoneNumber,
	uploadImageToFireStorage,
	getImageUrlFromFireStorage,
} from "../../firebase";
import { connect } from "react-redux";
import { phoneAuth, tcIsChecked } from "../../Store/Actions";
import { Camera, CameraOptions } from "@ionic-native/camera";
import { checkMediaQuery, validateMobileNumber } from "../../utils";
import { ToastMessage } from "../../utils/toastMessage";
import { Loader } from "../../utils/loader";

const LoginComponents: React.FC = (props: any) => {
	const [mobileNumber, setMobileNumber] = React.useState("");
	const [toast, setToast] = useState({
		showToast: false,
		toastMessage: "",
		severity: "",
	});
	const [loader, showLoader] = React.useState(false);

	const isDesktop = isPlatform("desktop");

	const options: CameraOptions = {
		destinationType: Camera.DestinationType.DATA_URL,
		sourceType: Camera.PictureSourceType.SAVEDPHOTOALBUM,
	};

	const handleMobileNumberChange = (num: string) => {
		if (num.length <= 10) {
			setMobileNumber(num);
		}
	};

	function formatError(error: any) {
		// console.log("Error ... 52 ===", error);
		if (error.includes("auth/")) {
			const splitted = error.split("/");
			if (splitted && splitted.length === 2) {
				let toastText = splitted[1].split("-").join(" ");
				setToast({
					showToast: true,
					toastMessage: toastText[0].toUpperCase() + toastText.slice(1).toLowerCase(),
					severity: "danger",
				} as any);
				return;
			}
		}
	}

	const validateMobileAndGetOpt = async () => {
		try {
			if (mobileNumber.length === 9 && !!validateMobileNumber(mobileNumber)) {
				showLoader(true);
				const result = await signInWithPhoneNumber("+971" + mobileNumber);
				if (typeof result === "object") {
					if (result) {
						props.phoneAuth({ result, mobileNumber });
						!!props.styleChangeReq
							? props.showOtp()
							: props.history.push({
									pathname: "/otp",
							  });
						showLoader(false);
					}
				} else {
					formatError(result);
				}
			} else {
				setToast({
					showToast: true,
					toastMessage: PLEASE_ENTER_VALID_MOBILE_NUMBER,
					severity: "warning",
				});
			}
		} catch (error: any) {
			setToast({
				showToast: true,
				toastMessage: JSON.stringify(error),
				severity: "danger",
			});
		}
	};
	const validateTcChecked = async (isChecked: boolean) => {
		try {
			showLoader(true);
			props.tcIsChecked(isChecked);
			showLoader(false);
		} catch (error: any) {
			setToast({
				showToast: true,
				toastMessage: JSON.stringify(error),
				severity: "danger",
			});
		}
	};

	const handleKeypress = (e: any) => {
		if (props.tcChecked && e.key === "Enter") {
			validateMobileAndGetOpt();
		}
	};

	return (
		<div className={props.styleChangeReq ? "login15 marginRight0" : "login15"}>
			<div className={props.styleChangeReq ? "login16 log_width100Per" : "login16"}>
				{props.styleChangeReq ? (
					<div className="loginheader">
						<img
							src={
								checkMediaQuery()
									? "/images/gray_backarrow.svg"
									: "/images/back_arrow.svg"
							}
							className="back_arrow"
							onClick={() => props.setLogin()}
						/>
						<IonLabel className={"login17 displayblock"} color="secondary">
							{LOGIN_OR_SIGNUP}
						</IonLabel>
						<div />
					</div>
				) : (
					<IonLabel className={"login17"} color="secondary">
						{LOGIN_OR_SIGNUP}
					</IonLabel>
				)}
				<div className={props.styleChangeReq && "anonymous_login_container"}>
					<CustomTextField
						{...props}
						label={MOBILE_NUMBER}
						fieldtype="numeric"
						onChange={(value: string) => handleMobileNumberChange(value)}
						value={mobileNumber}
						handleKeypress={(event: any) => handleKeypress(event)}
						changeStyle={props.styleChangeReq}
					/>
					<div className={!!props.styleChangeReq ? "anonymous_otpText" : "otpText"}>
						{OTP_TEXT}
					</div>
					<div className="tc_main_wrapper">
						<div className="tc_checkbox_wrapper">
							<IonCheckbox
								checked={props.tcChecked || false} //{checked}
								onIonChange={(e: any) => {
									validateTcChecked(e.detail.checked);
								}}
							/>
							<IonLabel className="tc_heading_text">{TERMS_AND_CONDITIONS_CAP}</IonLabel>
						</div>
						<div className="tc_text_wrapper">
							{" "}
							<span className="important">{IMPORTANT}</span> {T_AND_C_TEXT}
						</div>
					</div>
					<CutsomButtom
						label={CONTINUE}
						hasImg={false}
						className={"login-button"}
						disabled={props.tcChecked ? false : true}
						onClick={() => validateMobileAndGetOpt()}
					/>

					<CustomButtonMobile
						label={CONTINUE_USING_MOBILENUM}
						hasImg={true}
						className="login-button"
						onClick={() => props.history.push("/otp-verify")}
						disabled={props.tcChecked ? false : true}
						// onClick={() => validateMobileAndGetOpt()}
					/>
				</div>
			</div>
			<ToastMessage
				showToast={toast.showToast}
				ToastMessage={toast.toastMessage}
				severity={toast.severity}
				onDidDismiss={() => {
					setToast({
						showToast: false,
						toastMessage: "",
						severity: "",
					});
				}}
			/>
			{loader ? <Loader loader={loader} /> : null}
		</div>
	);
};

export default connect(
	({ auth: { result, mobileNumber, tcChecked } }: any) => {
		return { result, mobileNumber, tcChecked };
	},
	{ phoneAuth, tcIsChecked }
)(LoginComponents);
